<script setup lang="ts">
/**
 * Plain text whose URLs render as links (ADR-109: a licence notice is kept verbatim, and its URLs
 * must be clickable). A URL ends before a trailing `.`, `,`, `;`, `:` or `)`. External links open in
 * a new tab, so the builder or the sheet the notice sits in stays open.
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ text: string }>()
const { t } = useI18n()

const URL_PART = /(https?:\/\/\S+?)(?=[.,;:)]?(?:\s|$))/
const parts = computed(() =>
  props.text
    .split(URL_PART)
    .map((text, i) => ({ text, url: i % 2 === 1 }))
    .filter((p) => p.text !== ''),
)
</script>

<template>
  <template v-for="(part, i) in parts" :key="i">
    <a
      v-if="part.url"
      :href="part.text"
      target="_blank"
      rel="noopener noreferrer"
      class="break-words text-accent-text underline"
      >{{ part.text }}<span class="sr-only">{{ ' ' + t('linkedText.newTab') }}</span></a
    >
    <template v-else>{{ part.text }}</template>
  </template>
</template>
